import { Separator } from "components/core/Seperator";
import { OriginalSection } from "components/domain/contents/sections/OriginalSection";
import { RecentSection } from "components/domain/contents/sections/RecentSection";
import { Mix_Content_Tag_Enum_Enum } from "graphql/generated";
import { LIMIT, buildQueryVariables } from "utils/buildQueryVariables";

interface MobileTabletLayoutProps {
    tags: Mix_Content_Tag_Enum_Enum[] | null;
}

/**
 * Mobile/Tablet 레이아웃 (< 1025px)
 *
 * 표시 규칙:
 * - OriginalSection: tags === null일 때만 표시
 * - Separator: OriginalSection이 표시될 때 (모바일 전용)
 * - RecentSection: 항상 표시
 */
export const MobileTabletLayout = ({ tags }: MobileTabletLayoutProps) => {
    const showOriginalSection = tags === null;

    return (
        <div className="block lg:hidden">
            {/* OriginalSection: tags === null일 때만 표시 */}
            {showOriginalSection && (
                <div className="mb-0">
                    <OriginalSection
                        data-observer-id="original"
                        contentSection="original-main"
                        variables={buildQueryVariables(
                            "original",
                            null,
                            LIMIT.original
                        )}
                    />
                </div>
            )}

            {/* RecentSection: 항상 표시 */}
            <div className="mb-0">
                {/* Separator: OriginalSection이 표시될 때 (모바일 전용) */}
                {showOriginalSection && (
                    <Separator
                        className="mx-[calc(-1*var(--page-padding))]
                            my-[var(--section-mobile-gap)] flex w-auto
                            md:hidden"
                    />
                )}
                <RecentSection
                    data-observer-id="recent"
                    contentSection="recent"
                    variables={buildQueryVariables(
                        "recent",
                        tags,
                        LIMIT.default
                    )}
                />
            </div>
        </div>
    );
};
